
import { Component, Vue, Watch } from 'vue-property-decorator'
import { GET_CONFIG } from '~/graphql/gql/config'
import { GQLConfig } from '~/graphql/__generated__/interfaces'
import { isFeatureEnabled } from '~/utils/featureFlags'
import { GQL_LOCAL_ACCOUNT } from '~/graphql/gqlLocal/localAccount'
import { GQLLocalAccount } from '~/graphql/__generated__/interfacesLocal'

const DATA_BREAKERS_URL_SUFFIXES = {
  CZ10MA: 'mall_cz/default.js',
  HR10MA: 'mall_hr/default.js',
  HU20MA: 'mall_hu/default.js',
  PL20MA: 'mall_pl/default.js',
  SI10SI: 'mall_si/default.js',
  SK10MA: 'mall_sk/default.js',
}

@Component({
  apollo: {
    account: GQL_LOCAL_ACCOUNT,
    getConfig: {
      fetchPolicy: 'cache-only',
      query: GET_CONFIG,
    },
  },
})
export default class TheTrackingDataBreakers extends Vue {
  getConfig: GQLConfig
  account: GQLLocalAccount

  scriptAdded = false

  @Watch('account', { deep: true })
  addScript() {
    if (!this.scriptAdded && this.showScript && this.dataBreakersUrl) {
      const script = document.createElement('script')
      script.setAttribute('src', this.dataBreakersUrl)
      script.setAttribute('async', 'async')
      document.head.appendChild(script)
      this.scriptAdded = true
    }
  }

  get showScript() {
    return (
      (this.account?.consents?.gdprPersonalization &&
        isFeatureEnabled('dataBreakersTracker', this.getConfig)) ??
      false
    )
  }

  get dataBreakersUrl() {
    const suffix = DATA_BREAKERS_URL_SUFFIXES[this.$shopConfig?.shopId] ?? ''
    return this.$env?.dataBreakersBaseUrl && suffix
      ? `${this.$env?.dataBreakersBaseUrl}${suffix}`
      : ''
  }

  created() {
    this.addScript()
  }

  render() {
    return null
  }
}
